<template>
  <a-form :form="retrieveForm" @submit.prevent="submit">
    <a-form-item>
      <a-input
        placeholder="请输入手机号"
        v-decorator="[
          'telphone',
          {
            rules: [
              { required: true, message: '请输入手机号码' },
              { pattern: /^1[34578]\d{9}$/, message: '手机号码格式不正确' }
            ],
            validateTrigger: 'blur'
          }
        ]"
      ></a-input>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" html-type="submit" :loading="loading">下一步</a-button>
    </a-form-item>
  </a-form>
</template>
<script>
export default {
  name: '',
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      retrieveForm: this.$form.createForm(this, { name: 'retrieveForm' }),
    }
  },
  components: {
    // zTipsModal
    // InterestModal
  },
  methods: {
    submit() {
      this.retrieveForm.validateFields(async (error, values) => {
        if (error) {
          console.log('error', error)
          return
        }
        try {
          const { telphone } = values
          //   this.telphone = telphone
          // await featchCode({ telphone })
          //   this.visible = true
          this.$emit('next', telphone)
        } catch (error) {
          console.log(error)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import '../index.less';
</style>
